import { en } from './en'
import { prs } from './prs'
import { ps } from './ps'

export const strings = { ps, prs, en }
